import { useNavigate } from "react-router";
import { useTransferPaymentsContext } from "./useTransferPaymentsContext";
export function useTransferPayments() {
    const context = useTransferPaymentsContext();
    const navigate = useNavigate();
    return {
        formState: context.formState,
        formStage: context.formStage,
        transferId: context.fundsTransferId,
        fromAccount: context.fromAccount,
        toAccount: context.toAccount,
        transferType: context.transferType,
        isPending: context.isPending,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        createTransfer: (formstate) => {
            context.updateform(formstate);
            context.updateStage("Confirm");
        },
        confirmTransfer: (transferId) => {
            context.updateFundsTransfer(transferId);
            context.updateStage("Receipt");
        },
        confirmFromAccount: (fromAccount) => {
            context.updateFromAccount(fromAccount);
        },
        confirmToAccount: (toAccount) => {
            context.updateToAccount(toAccount);
        },
        updateTransferType: (transferType) => {
            context.updateTransferType(transferType);
        },
        updateIsPending: (isPending) => {
            context.updateIsPending(isPending);
        },
        modifyTransfer: () => {
            context.updateStage("Create");
        },
        returnToHome: () => {
            navigate(`/`);
        },
    };
}
